import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import info from '@/components/info'

function renderError(h) {
  if (this.showError) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services['report-manager']}.errors.noReportTypes`),
          color: Colors.error
        }
      }
    )
  }

  return null
}

export default function(h) {
  if (this.items.length === 0) {
    return renderError.call(this, h)
  }

  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        items: this.items,
        label: this.getTranslate(`${Services['report-manager']}.labels.type`),
        labelMode: this.labelMode,
        required: this.required,
        clearable: this.clearable,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
